export const SERVICE_ACCOUNT_PERMISSIONS = [
  { key: "view", label: "View" },
  { key: "edit", label: "Edit" },
  { key: "delete", label: "Delete" },
];

export const DEFAULT_SERVICE_ACCOUNT_PERMISSIONS = {
  view: true,
  edit: false,
  delete: false,
};

export function maskPrivateKey(key) {
  if (!key) return "—";
  if (key.length <= 12) return "••••••••";
  return `${key.slice(0, 7)}${"•".repeat(8)}${key.slice(-4)}`;
}

export function normalizeServiceAccountPermissions(permissions) {
  const source = permissions ?? {};
  return SERVICE_ACCOUNT_PERMISSIONS.reduce((acc, { key }) => {
    acc[key] = key in source ? Boolean(source[key]) : DEFAULT_SERVICE_ACCOUNT_PERMISSIONS[key];
    return acc;
  }, {});
}

export function serviceAccountToForm(serviceAccount) {
  if (!serviceAccount) {
    return {
      name: "",
      permissions: { ...DEFAULT_SERVICE_ACCOUNT_PERMISSIONS },
    };
  }
  return {
    name: serviceAccount.name ?? "",
    permissions: normalizeServiceAccountPermissions(serviceAccount.permissions),
  };
}

export function validateServiceAccountForm(form) {
  const errors = {};
  const name = form.name?.trim();
  if (!name) errors.name = "Service account name is required";
  const permissions = normalizeServiceAccountPermissions(form.permissions);
  if (!SERVICE_ACCOUNT_PERMISSIONS.some(({ key }) => permissions[key])) {
    errors.permissions = "Select at least one permission";
  }
  return errors;
}

export function serviceAccountFormToPayload(form) {
  return {
    name: form.name.trim(),
    permissions: normalizeServiceAccountPermissions(form.permissions),
  };
}

export function formatServiceAccountPermissions(permissions) {
  return SERVICE_ACCOUNT_PERMISSIONS.filter(({ key }) => normalizeServiceAccountPermissions(permissions)[key]).map(
    ({ label }) => label,
  );
}
